var _style, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgONasZadowoleniKlienci48 = function SvgONasZadowoleniKlienci48(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "o_nas_zadowoleni_klienci_48_svg__Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 48 48",
    style: {
      enableBackground: "new 0 0 48 48"
    },
    xmlSpace: "preserve"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".o_nas_zadowoleni_klienci_48_svg__st0{fill:#231f20}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "o_nas_zadowoleni_klienci_48_svg__st0",
    d: "M24.1 23.7c-4.2 0-7.7-3.5-7.7-7.7s3.5-7.7 7.7-7.7 7.7 3.5 7.7 7.7-3.4 7.7-7.7 7.7zm0-14.1c-3.5 0-6.4 2.9-6.4 6.4s2.9 6.4 6.4 6.4 6.4-2.9 6.4-6.4c.1-3.5-2.8-6.4-6.4-6.4z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "o_nas_zadowoleni_klienci_48_svg__st0",
    d: "M29.8 41.2H18.4c-2.3 0-4.2-1.9-4.2-4.2v-8.3L3 18.8c-1.2-1.1-1.4-3-.3-4.2s3-1.4 4.2-.3l9.9 8.7c1.9 1.9 4.5 3 7.3 3s5.3-1.1 7.3-3l9.9-8.7c1.2-1.1 3.1-1 4.2.3 1.1 1.2 1 3.1-.3 4.2L34 28.6V37c0 2.3-1.9 4.2-4.2 4.2zM4.9 14.8c-.5 0-1 .2-1.3.6-.6.7-.6 1.8.2 2.4L15.5 28v9c0 1.6 1.3 2.9 2.9 2.9h11.4c1.6 0 2.9-1.3 2.9-2.9v-8.9l11.7-10.2c.7-.6.8-1.7.2-2.4-.6-.7-1.7-.8-2.4-.2L32.3 24c-2.2 2.2-5.1 3.4-8.2 3.4s-6-1.2-8.2-3.4L6 15.3c-.3-.4-.7-.5-1.1-.5z"
  })));
};
export default SvgONasZadowoleniKlienci48;